/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, age: NonNullable<unknown> }} Profile_Birth_ValueInputs */

const en_us2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} years old`)
};

const pt_br2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} anos`)
};

const es_419_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} años`)
};

const pt_pt2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} anos`)
};

const fr_fr2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} ans`)
};

const de_de2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} Jahre`)
};

const it_it2_profile_birth_value = /** @type {(inputs: Profile_Birth_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} · ${i?.age} anni`)
};

/**
* | output |
* | --- |
* | "{date} · {age} years old" |
*
* @param {Profile_Birth_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_birth_value = /** @type {((inputs: Profile_Birth_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Birth_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_birth_value(inputs)
	if (locale === "es-419") return es_419_profile_birth_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_birth_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_birth_value(inputs)
	if (locale === "de-DE") return de_de2_profile_birth_value(inputs)
	if (locale === "it-IT") return it_it2_profile_birth_value(inputs)
	return en_us2_profile_birth_value(inputs)
});
export { profile_birth_value as "profile.birth_value" }